// src/store/slices/uiSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Types
export interface UIState {
  showChatDetails: boolean;
  showAddChatModal: boolean;
  showAssignLeadDrawer: boolean;
  showAssignChatDrawer: boolean;
  showDeleteConfirmation: boolean;
  openForm: null | 'task' | 'note';
showFbButton: boolean;
assignLeadHeaderTitle: string;
openLeadDrawer: boolean;
showLabelPopup: boolean;
showStatusPopup: boolean;
  loadingStates: {
    [key: string]: boolean;
  };
  searchInChat: boolean; // Search within current conversation
}

// Initial state
const initialState: UIState = {
  showChatDetails: false,
  showAddChatModal: false,
  showAssignLeadDrawer: false,
  showAssignChatDrawer: false,
  showDeleteConfirmation: false,
  loadingStates: {},
  searchInChat: false,
  openForm: null,
  showFbButton: false,
  assignLeadHeaderTitle: '',
  openLeadDrawer: false,
  showLabelPopup: false,
  showStatusPopup: false
};

// Create slice
const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setShowChatDetails: (state, action: PayloadAction<boolean>) => {
      state.showChatDetails = action.payload;
    },
    
    toggleChatDetails: (state) => {
      state.showChatDetails = !state.showChatDetails;
    },
    
    setShowAddChatModal: (state, action: PayloadAction<boolean>) => {
      state.showAddChatModal = action.payload;
    },
    
    setOpenForm: (state, action: PayloadAction<null | 'task' | 'note'>) => {
      state.openForm = action.payload;
    },
    setShowFbButton: (state, action: PayloadAction<boolean>) => {
      state.showFbButton = action.payload;
    },
    setAssignLeadHeaderTitle: (state, action: PayloadAction<string>) => {
      state.assignLeadHeaderTitle = action.payload;
    },
    setOpenLeadDrawer: (state, action: PayloadAction<boolean>) => {
      state.openLeadDrawer = action.payload;
    },
    setShowLabelPopup: (state, action: PayloadAction<boolean>) => {
      state.showLabelPopup = action.payload;
    },
    setShowStatusPopup: (state, action: PayloadAction<boolean>) => {
      state.showStatusPopup = action.payload;
    },
    setShowAssignLeadDrawer: (state, action: PayloadAction<boolean>) => {
      state.showAssignLeadDrawer = action.payload;
    },
    
    setShowAssignChatDrawer: (state, action: PayloadAction<boolean>) => {
      state.showAssignChatDrawer = action.payload;
    },
    
    setShowDeleteConfirmation: (state, action: PayloadAction<boolean>) => {
      state.showDeleteConfirmation = action.payload;
    },
    
    setSearchInChat: (state, action: PayloadAction<boolean>) => {
      state.searchInChat = action.payload;
    },
    
    setLoadingState: (state, action: PayloadAction<{ key: string; value: boolean }>) => {
      const { key, value } = action.payload;
      state.loadingStates[key] = value;
    },
    
    resetUI: (state) => {
      Object.assign(state, initialState);
    }
  }
});

// Export actions
export const {
  setShowChatDetails,
  toggleChatDetails,
  setShowAddChatModal,
  setShowAssignLeadDrawer,
  setShowAssignChatDrawer,
  setShowDeleteConfirmation,
  setSearchInChat,
  setLoadingState,
  resetUI,
  setOpenForm,
  setShowFbButton,
  setAssignLeadHeaderTitle,
  setOpenLeadDrawer,
  setShowLabelPopup,
  setShowStatusPopup
} = uiSlice.actions;

// Export selectors
export const selectShowChatDetails = (state: RootState) => state.whatsapp.ui.showChatDetails;
export const selectShowAddChatModal = (state: RootState) => state.whatsapp.ui.showAddChatModal;
export const selectShowAssignLeadDrawer = (state: RootState) => state.whatsapp.ui.showAssignLeadDrawer;
export const selectShowAssignChatDrawer = (state: RootState) => state.whatsapp.ui.showAssignChatDrawer;
export const selectShowDeleteConfirmation = (state: RootState) => state.whatsapp.ui.showDeleteConfirmation;
export const selectSearchInChat = (state: RootState) => state.whatsapp.ui.searchInChat;
export const selectOpenForm = (state: RootState) => state.whatsapp.ui.openForm;
export const selectShowFbButton = (state: RootState) => state.whatsapp.ui.showFbButton;
export const selectAssignLeadHeaderTitle = (state: RootState) => state.whatsapp.ui.assignLeadHeaderTitle;
export const selectOpenLeadDrawer = (state: RootState) => state.whatsapp.ui.openLeadDrawer;
export const selectShowLabelPopup = (state: RootState) => state.whatsapp.ui.showLabelPopup;
export const selectShowStatusPopup = (state: RootState) => state.whatsapp.ui.showStatusPopup;
export const selectLoadingState = (key: string) => (state: RootState) => 
  state.whatsapp.ui.loadingStates[key] || false;

// Export reducer
export default uiSlice.reducer;